const
	body = document.body,
	navBtn = document.getElementById('toggleMenu');

navBtn.addEventListener('click', function () {
	if (body.classList.contains('isOpen')) {
		body.classList.remove('isOpen');
		body.classList.add('isClose');
	} else {
		body.classList.add('isOpen');
		body.classList.remove('isClose');
	}
});



$(function(){
	const w = $(window);
    $('.moveScroll').find('a').on('click', function(e){
        e.preventDefault();
        var href= $(this).attr("href"),
        target = $(href == "#" || href == "" ? 'html' : href),
        position = target.offset().top;
        $("html, body").animate({scrollTop:position}, 1000, "swing");
        $('body').removeClass('isOpen');
        return false;
    });
    w.trigger('scroll');
});


$(window).on('load', function() {
    $('body').removeClass('preload');
});